import http from "./apiServices"
import { formatPayloadToParams } from "@utils/formatter"

export const getServicePackages = ({ type, ...payload } = {}) => {
  // the shared search tool rewrites its reserved `serviceType` id to `type`, because
  // every other list endpoint names that query param `type`. This one names it
  // `serviceType` (matching the ServicePackage column), so rename it back — otherwise
  // the whitelist drops it and the 服務類別 filter is silently ignored.
  if (type) payload.serviceType = type
  let params = formatPayloadToParams(payload, ["packageNo", "name", "serviceType", "state", "sort", "order"])
  return http.get("servicePackages", { params })
}

export const postServicePackage = (servicePackageInfo) => {
  return http.post("servicePackages", servicePackageInfo)
}

export const getServicePackageById = (servicePackageId) => {
  return http.get(`servicePackages/${servicePackageId}`)
}

// there is no delete route by design — deactivate with state: "inactive"
export const putServicePackageById = ({ servicePackageId, servicePackageInfo }) => {
  return http.put(`servicePackages/${servicePackageId}`, servicePackageInfo)
}
